module.exports = function() {
  return new Worker(__webpack_public_path__ + "c28cabcd591a4919653c.worker.js");
};


//////////////////
// WEBPACK FOOTER
// ../xod-client/dist/workers/wasm.worker.js
// module id = 1509
// module chunks = 0